import http from '@/shared/api/http'

export async function getAllProducts() {
  return (await http.get('products')).data
}

export async function getProductById(productId) {
  return (await http.get(`products/${productId}`)).data
}

export async function createProduct(payload) {
  return (await http.post('products', payload)).data
}

export async function updateProduct(productId, payload) {
  return (await http.put(`products/${productId}`, payload)).data
}

export async function deleteProduct(productId) {
  return (await http.delete(`products/${productId}`)).data
}
export async function searchProducts(query, limit = 20) {
  if (!query || query.length < 2) return []
  const response = await http.get('/products/search', { 
    params: { query, limit } 
  })
  return response.data
}
export async function getProductVariants(productId) {
  return (await http.get(`products/${productId}/variants`)).data
}

export async function createProductVariant(productId, payload) {
  return (await http.post(`products/${productId}/variants`, payload)).data
}

export async function updateProductVariant(productId, variantId, payload) {
  return (await http.put(`products/${productId}/variants/${variantId}`, payload)).data
}

export async function deleteProductVariant(productId, variantId) {
  return (await http.delete(`products/${productId}/variants/${variantId}`)).data
}